import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciDropdownComponent } from './luci-dropdown.component';
import {FormsModule} from '@angular/forms';
import {LuciChipsModule} from '../luci-chips/luci-chips.module';
import {LuciButtonModule} from '../luci-button/luci-button.module';
import {LuciSearchModule} from '../luci-search/luci-search.module';



@NgModule({
  declarations: [LuciDropdownComponent],
  exports: [LuciDropdownComponent],
  imports: [
    CommonModule,
    FormsModule,
    LuciChipsModule,
    LuciButtonModule,
    LuciSearchModule
  ]
})
export class LuciDropdownModule { }
